export const groupV1API = '/api/v1/groups';
export const crossPlatform = '/v1/api';
export const groupV2API = '/api/v2/groups';
export const phasesV1API = '/api/v1/phases';
export const adAccountsV1API = '/api/v1/adaccounts';
